<template>
    <div>
        <opening></opening>

        <market></market>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Opening from '../components/Buero/Merchant/MerchantDetail';
import Market from '../components/Buero/Market/Market';

export default {
    name: 'Buero',
    components: {Market, Opening},
    props: {
        merchant: Object,
    },

    created() {
        this.$store.dispatch('meinbuero/merchantInfo', this.merchant);
    },

    computed: mapGetters({
        merchantInfo: 'meinbuero/merchantInfo',
    }),
};
</script>
